var _defs, _path, _path2, _circle, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e24671f6-f501-4952-a2db-8b0b1d329c17",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "be92901b-ec33-4c65-adf1-9b0eed06d677",
    x1: 9,
    y1: 6.88,
    x2: 9,
    y2: 20.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b46fc246-25d8-4398-8779-1042e8cacae7",
    x1: 8.61,
    y1: -0.4,
    x2: 9.6,
    y2: 11.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-identity-230") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.72,18a1.45,1.45,0,0,0,1.45-1.45.47.47,0,0,0,0-.17C16.59,11.81,14,8.09,9,8.09S1.34,11.24.83,16.39A1.46,1.46,0,0,0,2.14,18H15.72Z",
    fill: "url(#be92901b-ec33-4c65-adf1-9b0eed06d677)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9.17a4.59,4.59,0,0,1-2.48-.73L9,14.86l2.44-6.38A4.53,4.53,0,0,1,9,9.17Z",
    fill: "#fff",
    opacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.01,
    cy: 4.58,
    r: 4.58,
    fill: "url(#b46fc246-25d8-4398-8779-1042e8cacae7)"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", {
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  }, /*#__PURE__*/React.createElement("rdfLi", null, "public:true"), /*#__PURE__*/React.createElement("rdfLi", null, "sdk:false"), /*#__PURE__*/React.createElement("rdfLi", null, "category: Identity")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.48242cae780ccec187043c1df95049c0.svg";
export { ForwardRef as ReactComponent };